var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakLightOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 482.7,
    width: 116,
    height: 230.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1.3,
    width: 508,
    height: 240
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_bb6eca30e"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.8,98.7l31.7-50.3h22.6l31.7,50.3h-17.1l-24.8-40.5h-2.2l-24.6,40.5h-17.3Z",
    fill: "#0096C7",
    stroke: "#0096C7",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.1,194.7V48.1h60.3c9.2,0,17.3,1.9,24.4,5.6,7.1,3.7,12.6,8.9,16.5,15.6,4,6.7,6,14.6,6,23.9v2.9c0,9.1-2.1,17-6.2,23.8-4.1,6.8-9.7,12-16.8,15.7-7.1,3.7-15.1,5.5-24,5.5h-32.7v53.6H15.1ZM42.8,116h30c6.6,0,11.9-1.8,15.9-5.4,4.1-3.6,6.1-8.6,6.1-14.9v-2.1c0-6.3-2-11.2-6.1-14.9-4-3.6-9.3-5.5-15.9-5.5h-30v42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.6,194.7V48.1h94.3v25.1h-66.6v35h60.8v25.1h-60.8v36.3h67.9v25.1h-95.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.6,194.7l38.5-146.6h48.2l38.5,146.6h-28.5l-8-32.3h-52.4l-8,32.3h-28.5ZM290.5,136.9h39.4l-17.8-71.4h-3.8l-17.8,71.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.4,194.7V48.1h27.6v58.2h3.8l47.5-58.2h35.4l-61.1,72.3,63.3,74.4h-36.4l-48.6-59.5h-3.8v59.5h-27.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakLightOverlay);
export default __webpack_public_path__ + "static/media/peak-light-overlay.b4445e261a46ffc86c5b71e93ab22897.svg";
export { ForwardRef as ReactComponent };